import { service } from '@ember/service';
import Route from '@ember/routing/route';
import SiteRedirectsMixin from 'client-portal/mixins/route/site-redirects';
import classic from 'ember-classic-decorator';

const LEADING_SLASHES = /^\/+/;

@classic
export default class SiteHomeRoute extends Route.extend(SiteRedirectsMixin) {
  @service router;
  @service session;
  @service bookingResume;

  async beforeModel(transition) {
    await super.beforeModel(...arguments);

    let { currentClient } = this.session;
    let redirect = this.bookingResume.consumeRedirect();
    let redirectTo = 'site.appointments';
    let { hasIncompleteDocument, permissions } = currentClient || {};
    let { isHeaderFooterHidden } = transition.to.queryParams;
    let params = isHeaderFooterHidden ? { isHeaderFooterHidden: true } : {};
    let redirectPath = redirect && this.#redirectPath(redirect, isHeaderFooterHidden);

    if (redirectPath) {
      redirectTo = redirectPath;
      params = {};
    } else if (hasIncompleteDocument || !permissions?.appointments) {
      redirectTo = 'site.documents';
    }

    this.router.transitionTo(redirectTo, { queryParams: params });
  }

  #redirectPath(redirect, isHeaderFooterHidden) {
    let decoded = this.#decodeRedirect(redirect);
    if (!decoded) return null;

    let [pathAndQuery] = decoded.replace(LEADING_SLASHES, '').split('#');
    let [path, query] = pathAndQuery.split('?');
    if (!path?.trim()) return null;

    let search = [query, isHeaderFooterHidden && 'isHeaderFooterHidden=true'].filter(Boolean);

    return `/${path}${search.length ? `?${search.join('&')}` : ''}`;
  }

  #decodeRedirect(redirect) {
    try {
      return decodeURIComponent(redirect);
    } catch (_err) {
      return null;
    }
  }
}
